import Utils from './utils';
import IframeDocumentRenderer from 'libs/iframe-document-renderer';

export default function(params) {
  this.config = params;

  ko.mapping.fromJS(params, {}, this);

  this.isNative = ko.observable(false);
  this.previewedDoc = ko.observable(false);

  this.title = ko.pureComputed({
    read: () => this.previewableFileName(),
    write: value => this.previewableFile().name(value)
  });

  this.previewableFileName = ko.computed(() => {
    return this.previewableFile() && this.previewableFile().name() || this.config.title;
  })

  this.enabled = ko.computed(() => {
    return true;
    // if (!this.document_conversion_job || ko.isObservable(this.document_conversion_job)) {
    //   return false;
    // } else {
    //   return this.isSuccessfulJob() || !!this.previewableFileUrl();
    // }
  });

  this.previewableFileSize = ko.computed(() => {
    return this.previewableFile() ? this.previewableFile().size() : 'N/A';
  })

  this.isSuccessfulJob = ko.computed(() => {
    if (typeof this.document_conversion_job.is_successful != 'function') {
      return false;
    } else {
      return this.document_conversion_job.is_successful();
    }
  });

  this.previewableFileUrl = ko.computed(() => {
    return this.previewableFile() && this.previewableFile().url()
  });

  this.previewableFile = ko.computed(() => {
    return this.document_conversion_job && this.document_conversion_job.previewable_file
  });

  this.transcode_status = ko.computed(() => {
    if (this.enabled()) {
      return 'complete';
    } else {
      return 'processing';
    }
  });

  this.disabled = ko.computed(() => !this.enabled());

  this.show = (_doc, event) => {
    if (this.disabled())
      return;

    if (!this.previewedDoc() && typeof this.document_conversion_job.id === 'function') {
      const $container = $('#js-video-' + this.id());

      const renderer = new IframeDocumentRenderer({
        id: this.document_conversion_job.id(),
        $container: $container.parent(),
        style: { height: 800 }
      });

      renderer.present();
      $container.remove();
      this.previewedDoc(true);
    }

    Utils.toggleRowVisibility(event);
  };

  return this;
}
